// src/utils/geo/index.js

// Distancias base
export const RADIUS_KM_RESTAURANTS = 5;   // Radio para restaurantes
export const RADIUS_KM_REPARTIDORES = 8;  // Radio para repartidores
export const RADIUS_KM_ADMINISTRADORES = 10;
export const DEFAULT_RADIUS_KM = RADIUS_KM_RESTAURANTS; // valor por defecto (compatibilidad)

// 🔹 Alias de compatibilidad (mantiene tu código existente funcionando)
export const RADIUS_KM = DEFAULT_RADIUS_KM;

// ------------------------------------------------------------
// Helpers
export const toNumber = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : NaN;
};

export const isValidCoord = (lat, lng) => {
    const la = toNumber(lat);
    const ln = toNumber(lng);
    return (
        Number.isFinite(la) &&
        Number.isFinite(ln) &&
        la >= -90 && la <= 90 &&
        ln >= -180 && ln <= 180
    );
};

// ------------------------------------------------------------
// Haversine (distancia en km)
export const distanceKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) ** 2;
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
};

// ------------------------------------------------------------
// Anotación y filtrado
export const annotateWithDistance = (user, items) =>
    (items || []).map((r) => ({
        ...r,
        _distanceKm: distanceKm(user.lat, user.lng, toNumber(r.lat), toNumber(r.lng)),
    }));

export const filterByRadius = (items, radiusKm = DEFAULT_RADIUS_KM) =>
    (items || [])
        .filter((r) => r._distanceKm <= radiusKm)
        .sort((a, b) => a._distanceKm - b._distanceKm);